import {Component, forwardRef, Inject} from '@angular/core';
import {AlertService} from "./services/alert.service";
import {ClientService} from "./services/client.service";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {UIService} from "./services/ui.service";
import {SessionService} from "./services/session.service";

@Component({
  selector: 'no-content',
  template: `

    <div style="text-align:center;margin-top:50px;">
      <img src="assets/img/emprez.png" style="width:150px;" class="img-responsive" />
    </div>
    <div style="text-align:center;margin-top:50px;">
      <h1 class="muted">404: {{'PageMissing' | translate}}</h1>
    </div>
  `
})
export class NoContentComponent {

  constructor(

      @Inject(forwardRef(() => UIService)) private uiService: UIService,
      @Inject(forwardRef(() => SessionService)) public session: SessionService,
  ) {

  }
}
